<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div class="status-icon">
    <icon-error
      v-if="status === 'ERROR'"
      class="error" />
    <icon-success
      v-else-if="status === 'DONE' || status === 'DONE_AMEND'"
      class="success" />
    <icon-warning
      v-else-if="status === 'WAIT_AMEND' || status === 'FAIL_AMEND'"
      class="warning-dark" />
    <loader-small v-else />
  </div>
</template>

<script type="text/babel">
  import { LoaderSmall } from '@/common/components/controls';
  import { IconError, IconSuccess, IconWarning } from '@/common/icons/monochrome';

  export default {
    components: {
      IconSuccess,
      IconError,
      IconWarning,
      LoaderSmall,
    },
    props: {
      status: {
        type: String,
        default: 'running',
      },
    },
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables' as *;

  div {
    display: inline-block;
    width: 2rem;
    height: 2rem;
    stroke-width: 0.2rem;

    .success {
      stroke: var(--success);
    }

    .error {
      stroke: var(--error);
    }

    .warning-dark {
      color: var(--warningDark) !important;
      stroke: var(--warningDark) !important;
      fill: var(--warningDark) !important;
    }
  }
</style>
